/** Built-in floating launcher icons — inline SVG with currentColor for the embed. */

export type LauncherIconPresetId =
    | 'chat-solid'
    | 'chat-edit'
    | 'chat-smile'
    | 'chat-thinking'
    | 'lightbulb'
    | 'chat-more';

export const LAUNCHER_ICON_PRESET_IDS: LauncherIconPresetId[] = [
    'chat-solid',
    'chat-edit',
    'chat-smile',
    'chat-thinking',
    'lightbulb',
    'chat-more',
];

export const LAUNCHER_ICON_PRESETS: Record<LauncherIconPresetId, string> = {
    'chat-solid': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/></svg>`,
    'chat-edit': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><path d="m14.5 6.5 3 3"/><path d="M12 11l-5.5 5.5"/></svg>`,
    'chat-smile': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/><path d="M9 11h.01"/><path d="M13 11h.01"/><path d="M9.5 14.5a3.5 3.5 0 0 0 5 0"/></svg>`,
    'chat-thinking': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/><path d="M12 7v1"/><path d="M12 11h.01"/><path d="M9.5 14.5a3.5 3.5 0 0 0 5 0"/></svg>`,
    lightbulb: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>`,
    'chat-more': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/><path d="M8 11h.01"/><path d="M12 11h.01"/><path d="M16 11h.01"/></svg>`,
};

export function isLauncherIconPresetId(
    value: string | null | undefined,
): value is LauncherIconPresetId {
    return (
        value != null &&
        LAUNCHER_ICON_PRESET_IDS.includes(value as LauncherIconPresetId)
    );
}
